import { List } from "immutable";
import { createSelector } from "reselect";

import { Content } from "../models/state/contents/Contents";
import { getAllContents, getSectionContentIds } from "./state";
import * as contentsSelectors from "./state/contents";

type State = any;

export function makeGetSectionContents(
  sectionId: string
): (arg0: State) => List<Content> {
  return createSelector(
    getAllContents,
    (state: any) => getSectionContentIds(state, sectionId),
    contentsSelectors.listExistingContents
  );
}

export function getSectionContents(state: State, sectionId: string) {
  const allContents = getAllContents(state);
  const contentIds = getSectionContentIds(state, sectionId);
  return contentsSelectors.listExistingContents(allContents, contentIds);
}
